import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { RequiresAccess } from '@interxfi/design-system/access-context';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { Button } from '@interxfi/design-system/components/button/button';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table/custom-header';
import PlusIcon from '@interxfi/design-system/icons/react/icon-plus';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../components/router/router-tabbed-navigation';
import { ApiKeysTable } from '../../../../../features/api-auth/api-keys-table';
import { CreateApiKeyDrawer } from '../../../../../features/api-auth/create-api-key-drawer';
import { DevelopersTabRail } from '../../../../../features/developer/developers-tab-rail';
import { getPageHead } from '../../../../../util/routing/meta';
import { useRollupViewContext } from '../../../../../util/view-context';

export const Route = createFileRoute('/_app/developer/api-key/_api-key/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.Developers,
      label: 'API Keys',
      order: 0,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.Developers>,
  head: () => getPageHead('API Keys'),
  component: ApiKeyList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <DevelopersTabRail
      actions={
        <HorizontalStack align="end" blockAlign="center" gap={2} wrap="nowrap">
          <RequiresAccess write>
            <CreateApiKeyDrawer trigger={<Button affixIcon={<PlusIcon aria-hidden />} aria-label="New API Key" size="small" />} />
          </RequiresAccess>
          {filter}
        </HorizontalStack>
      }
    />
  );
}

function ApiKeyList() {
  const viewContext = useRollupViewContext();

  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <ApiKeysTable HeaderActions={TableHeader} view={viewContext} />
      </PageLayout.Section>
    </PageLayout>
  );
}
